/* eslint-disable @typescript-eslint/camelcase */
import { Component } from 'vue-property-decorator'
import { FormStructure } from '@master/model/structure/FormStructure'
import { FormBaseMixin } from './FormBaseMixin'
import { DesignationOptions, NameCardOrder, NameCardOrderField, ProfesQualiOptions } from '@core/model/recruit/forms/NameCardOrder'
import { UserMeta } from '@core/model/common/UserMeta'

@Component
export class NameCardOrderFormMixin extends FormBaseMixin {
  private user: UserMeta
  protected type = NameCardOrder

  get companyName () {
    return this.projectInfo.companyShortName
  }

  get printerCompany () {
    return this.projectInfo.printerCompany
  }

  get fields (): NameCardOrderField {
    return this.formData.data as NameCardOrderField
  }

  get nameCardInfoStructure (): FormStructure<NameCardOrderField> {
    return [
      {
        label: 'Name to be Printed',
        key: 'printedName'
      },
      {
        label: 'Chinese Name',
        key: 'chineseName'
      },
      {
        label: 'Representative',
        key: 'designation',
        type: 'smart',
        options: DesignationOptions
      },
      {
        label: 'Academic Qualification',
        key: 'academic'
      },
      {
        label: 'Professional Qualification',
        key: 'professional',
        type: 'smart',
        multiple: true,
        options: ProfesQualiOptions
      },
      {
        label: 'Acknowledgement',
        key: 'acknowledgement',
        type: 'checkbox',
        checkboxColumnNo: 1,
        options: [
          {
            label: `I hereby give consent to the Company ("${this.printerCompany}") to use my personal data for the purpose of processing this order form.`,
            value: 'pdConsent'
          },
          {
            label: `I declare that all the information contained in this order form is true and accurate. If the name cards are printed based on the wrong information, I will NOT hold ${this.companyName} and ${this.printerCompany} accountable for any liabilities.`,
            value: 'trueInfo'
          },
          {
            label: `I understand that ${this.companyName} will conduct random checks on the order forms. Any false or misleading information found in the order forms may result in disciplinary actions taken by ${this.companyName}.`,
            value: 'randomChecks'
          }
        ]
      }
    ]
  }

  get accountDetailsStructure (): FormStructure<UserMeta> {
    return [
      {
        label: 'Facebook',
        key: 'facebook'
      },
      {
        label: 'Instagram',
        key: 'instagram'
      },
      {
        label: 'LinkedIn',
        key: 'linkedin'
      }
    ]
  }
}
